import { render, staticRenderFns } from "./CopyProductPackageDialog.vue?vue&type=template&id=14461602"
import script from "./CopyProductPackageDialog.vue?vue&type=script&lang=ts"
export * from "./CopyProductPackageDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports